import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RmsModule } from '@rms';
import { WebService, lastValueFrom, RmsPulldownService, RmsMessageService, RealtimeService } from '@services';
import { CreateCuppingSessionComponent } from './create-cupping-session/create-cupping-session.component';
import { CuppingDetailsComponent } from './cupping-details/cupping-details.component';
import { Column } from '@interfaces';
import { Subscription } from 'rxjs';

interface CuppingCoffee {
  id: number;
  label: string; // Ref # or "Offer Sample"
}

interface TableSlot {
  coffee: CuppingCoffee | null;
  slotNumber: number;
}

@Component({
  selector: 'app-coffee-cupping-session',
  standalone: true,
  imports: [CommonModule, RmsModule],
  templateUrl: './coffee-cupping-session.component.html',
  styleUrl: './coffee-cupping-session.component.scss'
})
export class CoffeeCuppingSessionComponent implements OnInit, OnDestroy {
    ViewSessionsScreen: boolean = false;
  dragOverSlot: any = null;
  CuppingSessions: any[] = [];
  CoffeesToCup: any[] = [];
  SelectedCuppingSession: any | null = null;
  selectedSlot: any | null = null;
  isDraggingGlobal = false;
  selectedCoffees = new Set<any>();
    SessionTables: any[] = []
    ActiveSession: any | null = null;
    ActivePreShip: any | null = null;
    Cupping: boolean = false;
    tables: any[] = []
    TodaysSessions: any[] = [];
    private intervalId: any;
    private socketSub?: Subscription;
    savingSession = false;
    completionNotifications: any[] = [];
    CompletedSessions: any[] = [];
    LastFiveSessions: any[] = [];
  CuppingSessionColumns: Column[] = [
    { label: 'Session ID', key: 'CuppingSessionKey', width: 20 },
      { label: 'Date', key: 'SessionDate', type: 'date', SearchType: 'date', },
      { label: 'Completed', type: 'checkbox', key: 'Completed', width: 10 },
  ]
  CoffeesToCupColumns: Column[] = [
    { label: 'Ref #/Offering Sample ID', key: 'InventoryID', width: 20 },
    { label: 'Coffee', key: 'InventoryTypeName', width: 40 },
  ]
    CuppingSessionDetailColumns: Column[] = [
        { label: 'Ref #/Offering Sample ID', key: 'InventoryID', width: 20 },
        { label: 'Coffee', key: 'InventoryTypeName', width: 40 },
        { label: 'Completed', key: 'Completed', width: 20, type: 'checkbox' },
        {label: 'Approved', key: 'WasApproved', width: 20, type: 'checkbox'}
    ]
    PreviousCuppingsColumns: Column[] = [
        { label: 'Session Date', key: 'SessionDate', type: 'date' },
        { label: 'Overall Score', key: 'Overall', },
        { label: 'Approved', key: 'WasApproved', type: 'checkbox'}
    ]
  // RIGHT SIDE — physical tables
  cuppingTables = {
    top: this.createSlots(),
    left: this.createSlots(),
    right: this.createSlots()
  };

  constructor(private web: WebService, private pulldown: RmsPulldownService, private message: RmsMessageService, private socket: RealtimeService) { }

  async ngOnInit() {
      clearInterval(this.intervalId);
      this.socketSub?.unsubscribe();
      await this.loadData();

      this.intervalId = setInterval(() => {
          this.reloadCuppingSession();
      }, 10000); // 10 seconds

      this.socketSub = this.socket.cuppingSessionUpdates$.subscribe(async (update) => {
          if (!update) return;

          const updates = Array.isArray(update) ? update : [update];
          console.log(updates);
        if (!this.Cupping && updates.length > 0) {
          if (updates[0].RecheckCoffees) {
            this.CoffeesToCup = await lastValueFrom(this.web.getWebCall('cupping', 'get_coffees_to_cup', { skipLoader: true }));
          }
          else {
            if (updates[0].Active == false) {
              this.ActiveSession = null;
              this.ActivePreShip = null;
            }
            else {
              this.ActiveSession = updates[0]
              if (updates[0].PreShipNotes) {
                this.ActivePreShip = updates[0].PreShipNotes[0];
              }
            }
          }
          }
      });

  }

    ngOnDestroy() {
        this.socketSub?.unsubscribe();
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }

    async loadData(forceReload: boolean = false) {
      const today = new Date();
      this.CuppingSessions = await lastValueFrom(this.web.getWebCall('cupping', 'get_cupping_sessions'));
      this.CoffeesToCup = await lastValueFrom(this.web.getWebCall('cupping', 'get_coffees_to_cup'));
        this.CuppingSessions.forEach((session: any) => {
            session.CuppingSessionDetails = JSON.parse(session.CuppingSessionDetails || '[]');
            session.SessionDate = new Date(session.SessionDate).toISOString().split('T')[0];
        });
        this.TodaysSessions = this.CuppingSessions.filter((cs: any) => cs.SessionDate == today.toISOString().split('T')[0]);

    } 
    async reloadCuppingSession() {
        const today = new Date();

        const sessions = await lastValueFrom(
            this.web.getWebCall('cupping', 'get_cupping_sessions', { skipLoader: true })
        );

        // Default to null
        //this.ActiveSession = null;

        sessions.forEach((session: any) => {
            session.CuppingSessionDetails = JSON.parse(session.CuppingSessionDetails || '[]');
            session.SessionDate = new Date(session.SessionDate).toISOString().split('T')[0];
        });

        this.TodaysSessions = sessions.filter(
            (cs: any) => cs.SessionDate === today.toISOString().split('T')[0]
        );
    }
    async UpdateCuppingSession(session?: any) {
    this.pulldown
      .open(CreateCuppingSessionComponent, { top: '0', data: session || {} })
      .afterClosed()
      .subscribe(async result => {
        if (!result) return;

        // save main session first
        const sessionRes: any = await lastValueFrom(
          this.web.getWebCall('cupping', 'merge_cupping_session', { body: result })
        );

        // depending on how your api returns data, adjust this line if needed
        const mergedSession = Array.isArray(sessionRes) ? sessionRes[0] : sessionRes?.[0] || sessionRes;
        const cuppingSessionKey =
          mergedSession?.CuppingSessionKey ||
          result?.CuppingSessionKey ||
          session?.CuppingSessionKey;

        const numberOfTables = Number(result.NumberOfTables || session?.NumberOfTables || 0);

        const body = Array.from({ length: numberOfTables }, (_, index) => {
          const tableNumber = index + 1;

          return {
            CuppingSessionKey: cuppingSessionKey,
            TableNumber: tableNumber,
            TableConfiguration: JSON.stringify(
              this.buildDefaultTableConfiguration(tableNumber, numberOfTables)
            )
          };
        });

        await lastValueFrom(
          this.web.getWebCall('cupping', 'merge_cupping_session_table', { body })
        );

        await this.loadData();
        this.message.success(`Cupping session ${session ? 'updated' : 'created'} successfully`);
      });
  }
  buildSessionTableBody(cuppingSessionKey: number, numberOfTables: number) {
    return Array.from({ length: numberOfTables }, (_, index) => {
      const tableNumber = index + 1;

      const existingTable = this.SessionTables?.find(
        (t: any) =>
          t.CuppingSessionKey === cuppingSessionKey &&
          t.TableNumber === tableNumber
      );

      return {
        CuppingSessionTableID: existingTable?.CuppingSessionTableID ?? null,
        CuppingSessionKey: cuppingSessionKey,
        TableNumber: tableNumber,
        TableConfiguration: existingTable?.TableConfiguration
          ? existingTable.TableConfiguration
          : JSON.stringify(this.buildDefaultTableConfiguration(tableNumber, numberOfTables))
      };
    });
  }
  buildTablesFromSession() {
    this.cuppingTables = {
      top: [],
      left: [],
      right: []
    };

    if (!this.SelectedCuppingSession) return;

    const sessionTables = this.SessionTables
      .filter((x: any) => x.CuppingSessionKey === this.SelectedCuppingSession.CuppingSessionKey)
      .sort((a: any, b: any) => a.TableNumber - b.TableNumber);

    for (const table of sessionTables) {
      const config =
        typeof table.TableConfiguration === 'string'
          ? JSON.parse(table.TableConfiguration)
          : table.TableConfiguration;

      if (config.position === 'top') {
        this.cuppingTables.top = config.slots || [];
      }

      if (config.position === 'left') {
        this.cuppingTables.left = config.slots || [];
      }

      if (config.position === 'right') {
        this.cuppingTables.right = config.slots || [];
      }
    }
  }
  buildDefaultTableConfiguration(tableNumber: number, numberOfTables: number) {
    let position = 'top';
    let orientation = 'horizontal';

    if (numberOfTables === 1) {
      position = 'top';
      orientation = 'horizontal';
    }

    if (numberOfTables === 2) {
      position = tableNumber === 1 ? 'left' : 'right';
      orientation = 'vertical';
    }

    if (numberOfTables === 3) {
      if (tableNumber === 1) {
        position = 'top';
        orientation = 'horizontal';
      } else if (tableNumber === 2) {
        position = 'left';
        orientation = 'vertical';
      } else {
        position = 'right';
        orientation = 'vertical';
      }
    }

    return {
      tableNumber,
      position,
      orientation,
      slots: Array.from({ length: 5 }, (_, i) => ({
        slotNumber: i + 1,
        coffee: null
      }))
    };
  }

  async SelectCuppingSession(event: any) {
    const session = event.row;

    this.SessionTables = await lastValueFrom(this.web.getWebCall('cupping', 'get_cupping_session_tables', { params: [{name: "CuppingSessionKey", value: session.CuppingSessionKey}]}))
    this.tables = this.SessionTables
      .filter(t => t.CuppingSessionKey === session.CuppingSessionKey)
      .sort((a, b) => a.TableNumber - b.TableNumber)
      .map(t => {
        const config = typeof t.TableConfiguration === 'string'
          ? JSON.parse(t.TableConfiguration)
          : t.TableConfiguration;

        return {
          tableNumber: t.TableNumber,
          position: config.position,
          orientation: config.orientation,
            slots: config.slots || [],
            completedSessions: config.completedSessions || []
        };
      });
      const completedMap = new Map<number, any>();

      for (const table of this.tables) {
          const completed = table.completedSessions || [];

          for (const item of completed) {
              if (!item?.CuppingSessionDetailID) continue;

              completedMap.set(item.CuppingSessionDetailID, item);
          }
      }

      this.CompletedSessions = Array.from(completedMap.values());
    this.SelectedCuppingSession = { ...session, editTables: !session.Completed };
  }

  getCoffeeDragPayload(coffee: any) {
    if (this.isDraggingGlobal && this.selectedCoffees.has(coffee)) {
      return {
        items: Array.from(this.selectedCoffees)
      };
    }

    return coffee;
  }
  onCoffeeDragStart(event: any, coffee: any) {
    this.isDraggingGlobal = true;

    if (!this.selectedCoffees.has(coffee)) {
      this.selectedCoffees.clear();
      this.selectedCoffees.add(coffee);
    }
  }

  onCoffeeDragEnd() {
    this.isDraggingGlobal = false;
  }
  async onDropToSlot(event: any, targetSlot: any) {
    this.dragOverSlot = null;
    const payload = event;
    const coffees = payload?.items ?? [payload];

    for (const coffee of coffees) {

      let previousSlot: any = null;

      // ✅ 1. Find and clear existing slot (movement logic)
      this.tables.forEach(table => {
        table.slots.forEach((slot: any) => {
          if (slot.coffee?.CuppingSessionDetailID === coffee.CuppingSessionDetailID) {
            previousSlot = slot;
          }
        });
      });

      // ✅ 2. If coffee came from another slot, remove it there
      if (previousSlot) {
        previousSlot.coffee = null;
      }

      // ✅ 3. If target slot already has coffee → push it back to pool
      if (targetSlot.coffee &&
        targetSlot.coffee.CuppingSessionDetailID !== coffee.CuppingSessionDetailID) {

        this.CoffeesToCup.push(targetSlot.coffee);

        // optional: mark old one as not on table
        await lastValueFrom(
          this.web.getWebCall('cupping', 'set_coffee_on_table', {
            params: [
              { name: 'CuppingSessionDetailID', value: targetSlot.coffee.CuppingSessionDetailID },
              { name: 'OnCuppingTable', value: false },
              { name: 'CuppingSessionKey', value: this.SelectedCuppingSession?.CuppingSessionKey ?? null }
            ]
          })
        );
      }

      // ✅ 4. Assign new coffee
      targetSlot.coffee = coffee;

      // ✅ 5. Mark as on table in DB
      await lastValueFrom(
        this.web.getWebCall('cupping', 'set_coffee_on_table', {
          params: [
            { name: 'CuppingSessionDetailID', value: coffee.CuppingSessionDetailID },
            { name: 'OnCuppingTable', value: true },
            { name: 'CuppingSessionKey', value: this.SelectedCuppingSession?.CuppingSessionKey ?? null }

          ]
        })
      );

      // ✅ 6. Remove from source list
      this.CoffeesToCup = this.CoffeesToCup.filter(
        c => c.CuppingSessionDetailID !== coffee.CuppingSessionDetailID
      );
    }

    // ✅ 7. Refresh list (your existing logic)
    this.CoffeesToCup = await lastValueFrom(
      this.web.getWebCall('cupping', 'get_coffees_to_cup')
    );

    // ✅ 8. Persist table JSON
    await this.saveTableForSlot(targetSlot);
  }
  async saveTableForSlot(slot: any) {
    if (!this.SelectedCuppingSession) return;

    // ✅ 1. Find the table this slot belongs to
    const table = this.tables.find(t =>
      t.slots.some((s: any) => s === slot)
    );

    if (!table) return;

    // ✅ 2. Build JSON config (what your DB stores)
    const config = {
      tableNumber: table.tableNumber,
      position: table.position,
      orientation: table.orientation,
        slots: table.slots,
      completedSessions: this.CompletedSessions
    };

    // ✅ 3. Call your MERGE proc
    const body = [
      {
        CuppingSessionKey: this.SelectedCuppingSession.CuppingSessionKey,
        TableNumber: table.tableNumber,
        TableConfiguration: JSON.stringify(config)
      }
    ];

    await lastValueFrom(
      this.web.getWebCall('cupping', 'merge_cupping_session_table', { body })
    );
  }
    async openSlotDetail(slot: any) {
      if(this.SelectedCuppingSession?.Completed) { this.message.info("This session is complete. Review results in Cupping Samples."); return; }
    if(this.SelectedCuppingSession?.Completed) { this.message.info("This session is complete. Review its results in Cupping Samples."); return; }
        console.log(slot);
      let flavorNotes = await lastValueFrom(this.web.getWebCall('files', `/list?path=${encodeURIComponent('/flavor_notes')}`))
        if (!slot.coffee.PreShip && !slot.coffee.OfferSampleID) {
          let preshipCoffee = await lastValueFrom(this.web.getWebCall('cupping', 'get_preship_cupping_detail', { params: [{ name: 'InventoryID', value: slot.coffee.InventoryID }] }))
          slot.coffee.PreShipNotes = preshipCoffee;
        }
        if (!slot.coffee.OfferSampleID) {
            let previousCuppings = await lastValueFrom(this.web.getWebCall('cupping', 'get_previous_cupping_details', { params: [{ name: 'InventoryID', value: slot.coffee.InventoryID }, { name: 'CuppingSessionDetailID', value: slot.coffee.CuppingSessionDetailID }] }))
            slot.coffee.PreviousCuppings = previousCuppings;
        }
      
    flavorNotes = flavorNotes.map((fn: any) => {
      return {
        ...fn,
        labelName: fn.name.split(".")[0]
      }
    })
      this.Cupping = true;
      const data = { coffee: slot.coffee, flavorNotes: flavorNotes };
      await lastValueFrom(this.web.getWebCall('cupping', 'socket/update-cupping', { body: slot.coffee, skipLoader: true }))
      const ref = this.pulldown.open(CuppingDetailsComponent, {
          data: data,
          top: '0',
        title: `Details for ${slot.coffee.InventoryTypeName} - ${slot.coffee.OfferSampleID ? 'Offer Sample ID: ' : 'Reference Number: '} ${slot.coffee.InventoryID} ${slot.coffee.PurchaseOrderID > 0 ? '- PO: ' + slot.coffee.PurchaseOrderID : ''} ${slot.coffee.PreShip ? 'PreShip Sample' : 'Arrival Sample'}. Supplier: ${slot.coffee.SupplierName} ${slot.coffee.OfferSampleID ? '' : '- Destination Warehouse: ' + slot.coffee.DestinationWarehouse}`,
          maxWidth: '96vw',
          width: 'min(1280px, 96vw)',
          maxHeight: '100vh'
      })
      ref.returnData().subscribe(async (updatedData: any) => {
          await lastValueFrom(this.web.getWebCall('cupping', 'socket/update-cupping', {body: updatedData, skipLoader: true}))
      })
      ref.afterClosed().subscribe(async(result: any) => {
          this.Cupping = false;
          await lastValueFrom(this.web.getWebCall('cupping', 'socket/update-cupping', { body: {Active: false}, skipLoader: true }))
          if (!result) return

        const index = this.CompletedSessions.findIndex(
            (c: any) => c.CuppingSessionDetailID === result.CuppingSessionDetailID
        );

        if (index !== -1) {
            // Replace existing
            this.CompletedSessions[index] = result;
        } else {
            // Add new
            this.CompletedSessions.push(result);
        }
        console.log(result);
        for (const table of this.tables) {
            const _slot = table.slots.find(
                (s: any) => s.coffee?.CuppingSessionDetailID === result.CuppingSessionDetailID
            );

            if (_slot) {
                _slot.coffee = result;
              _slot.coffee.flavorNotes = result.flavorNotes;
              _slot.coffee.Recup = result.Recup ?? false;
                break;
            }
        }
          await this.saveTableForSlot(slot);
    })
  }

  closeSlotDetail() {
    this.selectedSlot = null;
  }
  async onRemoveFromTable(event: any) {
    const coffee = event;

    // ✅ 1. find the slot it came from
    const slot = this.findSlotByCoffee(coffee);

    if (!slot) return;

    // ✅ 2. clear the slot
    slot.coffee = null;

    // ✅ 3. update DB flag
    await lastValueFrom(
      this.web.getWebCall('cupping', 'set_coffee_on_table', {
        params: [
          { name: 'CuppingSessionDetailID', value: coffee.CuppingSessionDetailID },
          { name: 'OnCuppingTable', value: false },
          { name: 'CuppingSessionKey', value: null }
        ]
      })
    );

    // ✅ 4. refresh list (your existing pattern)
    this.CoffeesToCup = await lastValueFrom(
      this.web.getWebCall('cupping', 'get_coffees_to_cup')
    );

    // ✅ 5. persist updated table
    await this.saveTableForSlot(slot);
  }

  findSlotByCoffee(coffee: any) {
    for (const table of this.tables) {
      for (const slot of table.slots) {
        if (slot.coffee?.CuppingSessionDetailID === coffee.CuppingSessionDetailID) {
          return slot;
        }
      }
    }
    return null;
  }

  private createSlots(): TableSlot[] {
    return Array.from({ length: 5 }, (_, i) => ({
      slotNumber: i + 1,
      coffee: null
    }));
  }

  onSlotDragEnter(slot: any) {
    this.dragOverSlot = slot;
  }

  onSlotDragLeave(slot: any) {
    if (this.dragOverSlot === slot) {
      this.dragOverSlot = null;
    }
  }

  isSlotDragOver(slot: any) {
    return this.dragOverSlot === slot;
  }
    get canCompleteSession(): boolean {
      const coffees = this.tables.flatMap(t => t.slots || []).filter(s => s.coffee).map(s => s.coffee);
      return !this.SelectedCuppingSession?.Completed && coffees.length > 0 && coffees.every(coffee => this.CompletedSessions.some(d => d.CuppingSessionDetailID === coffee.CuppingSessionDetailID && d.Completed));
    }
    async CompleteSession() {
      if (this.savingSession || !this.canCompleteSession) return;
      this.savingSession = true;
      const ids = new Set(this.tables.flatMap(t => t.slots || []).filter(s => s.coffee).map(s => s.coffee.CuppingSessionDetailID));
      const details = this.CompletedSessions.filter(d => ids.has(d.CuppingSessionDetailID)).map(detail => ({
        ...detail,
        InventoryID: detail.OfferSampleID ? null : detail.InventoryID,
        FlavorNotes: JSON.stringify((detail.flavorNotes || []).map((n: any) => ({FlavorNoteName:n.label, SessionSeqNum:n.order}))),
        CuppingSessionKey: this.SelectedCuppingSession.CuppingSessionKey
      }));
      try {
        const result = await lastValueFrom(this.web.getWebCall('cupping', 'complete_session', {body:{session:this.SelectedCuppingSession, details}}));
        this.SelectedCuppingSession = null;
        this.CompletedSessions = [];
        await this.loadData();
        this.message.success('Cupping session completed successfully');
        this.completionNotifications = result.notifications || [];
        if (this.completionNotifications.some(n => n.recipients.length)) this.message.info("Rejection email notifications simulated. No emails were sent.");
          try { await this.loadData(); } catch { this.message.error('Session saved, but the list could not refresh. Please refresh this screen.'); }
      } catch { this.message.error('Unable to complete the session. Your scoring is still available; please retry.'); }
      finally { this.savingSession = false; }
    }
    async StartCuppingSession() {
        if(this.SelectedCuppingSession?.Completed) return;
        this.SelectedCuppingSession.CuppingSessionStart = this.SelectedCuppingSession.editTables ? new Date() : null;
        await lastValueFrom(this.web.getWebCall('cupping', 'merge_cupping_session', {body: this.SelectedCuppingSession}))

        this.SelectedCuppingSession.editTables = !this.SelectedCuppingSession.editTables
    }
}
